export default "<div class=\"spinner\">\r\n  <mat-spinner></mat-spinner>\r\n</div>\r\n"